import { render, staticRenderFns } from "./14.vue?vue&type=template&id=2572c954&scoped=true&"
var script = {}
import style0 from "./14.vue?vue&type=style&index=0&id=2572c954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2572c954",
  null
  
)

export default component.exports